/**
 * Names an operator recognises, for the runtime components the API reports.
 *
 * The API returns enum values because they are a stable contract. An alarm banner that
 * says HOT_CACHE tells an operator less than one that says "playout hot cache", and an
 * alarm is exactly the moment to be legible.
 */
export const COMPONENT_LABELS: Readonly<Record<string, string>> = {
  API: 'Control API',
  DATABASE: 'PostgreSQL',
  QUEUE: 'Redis',
  STORAGE: 'Canonical storage',
  HOT_CACHE: 'Playout hot cache',
  PLAYOUT_AGENT: 'Playout agent',
  LIQUIDSOAP: 'Playout engine',
  ICECAST: 'Stream server',
  PRIMARY_SOURCE: 'Primary source',
  EMERGENCY_SOURCE: 'Emergency source',
  STREAM_PROBE: 'Listener-side stream probe',
  SILENCE_DETECTOR: 'Silence detection',
  METADATA_FRESHNESS: 'Metadata freshness',
  TIME_SYNC: 'Clock synchronisation',
  ARCHIVE_STORAGE: 'Archive storage',
  LIVE_SESSION: 'Live session',
  JOB_BACKLOG: 'Job backlog',
};
